export const sortSearchParams = (data?: string | null): Array<[string, string]> | null => {
	const entries: [string, any][] | undefined = data?.split(',')
		.map((s: string) => s.split(':', 2).map(decodeURIComponent) as [string, string])
	return entries ?? null
}
